import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useShoppingContext } from "../context/ShoppingContext";
import {
  faPlus,
  faMinus,
  faEdit,
  faTrash,
  faSave,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import AddTiposHuevosForm from "../Granja/Add/Forms/AddTiposHuevosForm/AddTiposHuevosForm";
import "./TiposHuevo.css";

const TiposHuevo = () => {
  const { tiposHuevos, fetchTiposHuevos, showAddEgg, setShowAddEgg } =
    useShoppingContext();
  const [editMode, setEditMode] = useState(null); // Estado para saber qué tipo de huevo se está editando
  const [newNombre, setNewNombre] = useState(""); // Estado para guardar el nuevo nombre del tipo de huevo

  useEffect(() => {
    fetchTiposHuevos();
  }, [fetchTiposHuevos]);

  const handleDelete = async (id) => {
    if (
      window.confirm("¿Estás seguro de que deseas eliminar este tipo de huevo?")
    ) {
      try {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/tipos-huevos/${id}`
        );
        fetchTiposHuevos();
      } catch (error) {
        console.error("Error al eliminar el tipo de huevo:", error);
      }
    }
  };

  const handleEdit = (id, nombre) => {
    setEditMode(id);
    setNewNombre(nombre);
  };

  const handleSave = async (id) => {
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}/tipos-huevos/${id}`, {
        nombre: newNombre,
      });
      setEditMode(null);
      fetchTiposHuevos();
    } catch (error) {
      console.error("Error al actualizar el tipo de huevo:", error);
    }
  };

  return (
    <div className="huevos-container">
      <h2 className="title">Tipos de Huevo</h2>
      <div className="tipos-huevos-list">
        {tiposHuevos.map((tipo) => (
          <div className="tipo-huevo-card" key={tipo.id}>
            {editMode === tipo.id ? (
              <div className="tipo-huevo-edit">
                <input
                  type="text"
                  value={newNombre}
                  onChange={(e) => setNewNombre(e.target.value)}
                  className="edit-input"
                />
                <button
                  onClick={() => handleSave(tipo.id)}
                  className="btn save-btn"
                >
                  <FontAwesomeIcon icon={faSave} /> Guardar
                </button>
              </div>
            ) : (
              <>
                <h3 className="tipo-huevo-nombre">{tipo.nombre}</h3>
                <div className="action-buttons">
                  <button
                    onClick={() => handleEdit(tipo.id, tipo.nombre)}
                    className="btn edit-button"
                  >
                    <FontAwesomeIcon icon={faEdit} /> Editar
                  </button>
                  <button
                    onClick={() => handleDelete(tipo.id)}
                    className="btn delete-button"
                  >
                    <FontAwesomeIcon icon={faTrash} /> Eliminar
                  </button>
                </div>
              </>
            )}
          </div>
        ))}
      </div>

      <div
        className="add-tipo-huevo"
        onClick={() => setShowAddEgg(!showAddEgg)}
      >
        {!showAddEgg ? (
          <>
            <FontAwesomeIcon icon={faPlus} /> Añadir Tipo de Huevo
          </>
        ) : (
          <>
            <FontAwesomeIcon icon={faMinus} /> Ocultar Formulario
          </>
        )}
      </div>

      {showAddEgg && <AddTiposHuevosForm />}
    </div>
  );
};

export default TiposHuevo;
